import React, { Component, Fragment } from 'react';
import { Typography, Grid, List, ListItem, ListItemSecondaryAction, ListItemText, Card, Box } from '@mui/material';
import { isEmpty } from 'lodash';
import Dialog from '../../common/Dialog';
import Currency from '../../common/Currency';
import { incomePaymentAmount, isPartialIncomePayment, incomePaymentsTotal, incomePaymentRefs } from './incomePaymentAmount';


class IncomePayments extends Component {
    componentDidMount = async () => {
        const { income } = this.props;
        if (isEmpty(income.payments)){
            await this.props.fetchIncomePayments(this.props.income.income_id)
        }
    }
    
    // rmPayment = (payID) => {
	// 	let newList = [].concat(this.state.checkedPayments)
	// 	newList = newList.filter(id => id !== payID)
	// 	this.setState({
    //         checkedPayments : newList,
	// 		totalPay: this.calcTotal(newList)
    //     });
	// }

    render() {
        const { income } = this.props;
        // Calculé au rendu : la liste arrive par le store après le montage, un total pris
        // dans componentDidMount restait à zéro. Et c'est la part rattachée à cette recette
        // qui compte, pas le montant du paiement, qui peut être réparti sur plusieurs recettes.
        const totalPay = incomePaymentsTotal(income.payments);
        return (
            // <Dialog
            //     title={`Recette du ${new Date(income.income_date).toLocaleDateString("fr-FR")} - Paiements liés`}
            //     close={this.props.handleClose}
            //     maxWidth="md"
            // >
            //     <Grid container>
            //         <Grid item xs={12} sm={6}>
            //             <Box p={1}>
            //                 <Card >
            //                     <Box p={1}>
            //                         <List>                                      
            //                             <ListItem>
            //                                 <ListItemText
            //                                     primary={
            //                                         <Typography variant="h6">Reste à pointer:</Typography>
            //                                     }
            //                                 /> 
            //                                 <ListItemSecondaryAction>
            //                                     <ListItemText 
            //                                         color="secondary"
            //                                         primary={
            //                                             <Typography color="secondary" variant="subtitle1">
            //                                                 <Currency suffix=" FCFA" value={income.income_total_available} />
            //                                             </Typography>
            //                                         }
            //                                     />
            //                                 </ListItemSecondaryAction>
            //                             </ListItem>  
            //                             <ListItem>
            //                                 <ListItemText
            //                                     primary={
            //                                         <Typography >Montant total:</Typography>
            //                                     }
            //                                 /> 
            //                                 <ListItemSecondaryAction>
            //                                     <ListItemText 
            //                                         color="secondary"
            //                                         primary={
            //                                             <Typography variant="subtitle1">
            //                                                 <Currency suffix=" FCFA" value={income.income_amount} />
            //                                             </Typography>
            //                                         }
            //                                     />
            //                                 </ListItemSecondaryAction>
            //                             </ListItem>                                                
            //                             <ListItem>
            //                                 <ListItemText
            //                                     primary={
            //                                         <Typography>Date encaissement:</Typography>
            //                                     }
            //                                 /> 
            //                                 <ListItemSecondaryAction>
            //                                     <ListItemText 
            //                                         primary={new Date(income.income_date).toLocaleDateString("fr-FR")}
            //                                     />
            //                                 </ListItemSecondaryAction>
            //                             </ListItem>
                                            
            //                             <ListItem>
            //                                 <ListItemText
            //                                     primary={
            //                                         <Typography>Banque:</Typography>
            //                                     }
            //                                 /> 
            //                                 <ListItemSecondaryAction>
            //                                     <ListItemText primary={BANKS[income.income_bank].bank_name} />
            //                                 </ListItemSecondaryAction>
            //                             </ListItem>
            //                             <ListItem>
            //                                 <ListItemText
            //                                     primary={
            //                                         <Typography>Poste:</Typography>
            //                                     }
            //                                 /> 
            //                                 <ListItemSecondaryAction>
            //                                     <ListItemText primary={POSTS[income.income_post].post_name} />
            //                                 </ListItemSecondaryAction>
            //                             </ListItem>
            //                         </List>
            //                         <Box p={1}>
            //                             <Typography variant="caption">{income.income_desc}</Typography>
            //                         </Box>
            //                     </Box>
            //                 </Card>                            
            //             </Box>
            //         </Grid>
            //         <Grid item xs={12} sm={6}>
                        <List style={{ maxHeight: "500px", overflow: "auto"}}>
                            <ListItem>
                                <ListItemText 
                                    primary={<Typography variant="body1" >Total</Typography>}
                                />
                                <ListItemSecondaryAction>
                                    <ListItemText 
                                        secondary={
                                            <Typography variant="h6" color="secondary" >
                                                <Currency value={totalPay} />
                                            </Typography>
                                        } 
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            {income.payments && income.payments.map( pay =>
                                incomePaymentAmount(pay) > 0 &&
                                    <ListItem key={pay.paymentID || pay.timePayment}>
                                    {/* <ListItemAvatar onClick={() => this.rmPayment(payID)} style={{ cursor: "pointer"}}>
                                        <CloseRounded color="error" />
                                    </ListItemAvatar> */}
                                    <ListItemText
                                        // domainModel ne sert pas userName à la 5000 : sans lui, la ligne
                                        // n'avait aucun titre. Les identifiants 8000 permettent de
                                        // retrouver le paiement dans la liste PAYGo.
                                        primary={pay.userName || new Date(pay.timePayment).toLocaleString('fr-FR')}
                                        secondary={
                                            <Fragment>
                                                {pay.userName &&
                                                    <span style={{ display: "block" }}>
                                                        {new Date(pay.timePayment).toLocaleString('fr-FR')}
                                                    </span>
                                                }
                                                {incomePaymentRefs(pay).map(ref =>
                                                    <span key={ref.label} style={{ display: "block" }}>
                                                        {ref.label} : <span style={{ fontFamily: "monospace" }}>{ref.value}</span>
                                                    </span>
                                                )}
                                            </Fragment>
                                        }
                                    />
                                    <ListItemSecondaryAction>
                                        <ListItemText
                                            secondary={<Currency value={incomePaymentAmount(pay)} />}
                                            // Paiement réparti sur plusieurs recettes : on rappelle son montant total.
                                            primary={isPartialIncomePayment(pay) ?
                                                <Typography variant="caption">
                                                    sur <Currency value={pay.money} />
                                                </Typography>
                                                : undefined
                                            }
                                        />
                                    </ListItemSecondaryAction>
                                </ListItem>
                            )}
                        </List>
            //          </Grid>
            //     </Grid>
            // </Dialog> 
        );
    }
}

export default IncomePayments;